import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button, { KINDS } from '@medflex/components/stories/Button';
import Tooltip from '@medflex/components/stories/Tooltip';

export const MODE = {
  FIXED: 'FIXED',
  CAROUSEL: 'CAROUSEL',
};

const SessionChatModuleQuickReply = ({ snippets, mode = MODE.FIXED, onClick, containerRef }) => {
  const ulCn = classNames('flex font-semibold', {
    'flex-nowrap overflow-x-auto': mode === MODE.CAROUSEL,
    'flex-wrap justify-center': mode === MODE.FIXED,
  });

  const liCn = 'pl-2 pb-2 last:pr-2';

  const handleClick = useCallback(
    snippet => event => {
      event.preventDefault();
      onClick(snippet);
    },
    [onClick],
  );

  if (!snippets?.length) return null;

  return (
    <ul className={ulCn} ref={containerRef}>
      {snippets.map(snippet => (
        <li key={`reply-${snippet.id}`} className={liCn}>
          <Tooltip title={snippet.title} preventOverflow>
            <Button
              className="flex-shrink-0 rounded-full bg-white border border-blue-500 hover:text-blue-600 hover:no-underline"
              onClick={handleClick(snippet)}
              kind={KINDS.LINK}
            >
              <span className="p-2 truncate max-w-[250px]">{snippet.title}</span>
            </Button>
          </Tooltip>
        </li>
      ))}
    </ul>
  );
};

SessionChatModuleQuickReply.propTypes = {
  snippets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      text: PropTypes.string,
      files: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          mediaType: PropTypes.string.isRequired,
          bytes: PropTypes.number.isRequired,
          detectedMediaType: PropTypes.string.isRequired,
        }),
      ),
      tags: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
        }),
      ),
    }),
  ),
  mode: PropTypes.oneOf(Object.values(MODE)),
  onClick: PropTypes.func.isRequired,
  containerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default SessionChatModuleQuickReply;
